import { useState, useContext, useEffect } from 'react';
import FormGroup from '../../FormGroup';
import SectionHeader from '../../SectionHeader';
import GlobalContext from '../../../contexts/index';
import CreateCustomer from '../../Customers/componenets/create';
import Button from '../../Button';
import fields from '../fields';
import usePostData from '../../../hooks/usePostData';
import { useNavigate } from 'react-router-dom';
import { isValidIsraeliID } from 'utils';

import orgTranslating from '../translate.json';
import globalTranslating from 'translate.json';

const AddOrganization = () => {
  const translating = { ...globalTranslating, ...orgTranslating };
  const { setLink } = useContext(GlobalContext);
  const navigate = useNavigate();
  const { postData, res, error } = usePostData();
  const [organizationAdded] = useState(false);
  const [addClientToOrg, setAddClientToOrg] = useState(false);
  const [errFun, setErrFun] = useState();

  useEffect(() => {
    if (error) {
      errFun?.set('apiError', {
        type: 'string',
        message: error.apiError
      });
    } else if (res?.id) {
      setLink(null);
      navigate(`/organizations?added=true`);
    }
  }, [res, error]);

  const onSubmit = (data, setError) => {
    setErrFun({ set: setError });
    if (!isValidIsraeliID(data.ssn))
      setError('ssn', {
        type: 'invalidTZ',
        message: translating.invalidTZ
      });
    else {
      console.log('create org', data);
      let deepData = { ...data };
      deepData.address = `${deepData.city},${deepData.street},${deepData.buildingNumber},${deepData.apartmentNumber},`;
      delete deepData.city;
      delete deepData.street;
      delete deepData.buildingNumber;
      delete deepData.apartmentNumber;
      postData('organization', deepData);
    }
  };

  const handleAddCustomer = () => {
    setAddClientToOrg(true);
  };

  return (
    <div className="create-organization">
      <SectionHeader
        title={translating.createOrganizationTitle}
      ></SectionHeader>
      <FormGroup fields={fields()} onSubmit={onSubmit}></FormGroup>
      {organizationAdded && (
        <Button
          txt={translating.addCustomerButton}
          handleClick={handleAddCustomer}
          variant="contained"
        ></Button>
      )}
      {addClientToOrg && <CreateCustomer></CreateCustomer>}
    </div>
  );
};

export default AddOrganization;
